<template>
  <div>
      <div v-if="(items !== null && loading == false) && (items.length > 0)">
        <div class="row bottom-border">
          <span class="header status">Status</span>
          <span class="header program-name">{{getProgramLabel(false, false)}} Name</span>
          <span class="header budget text-right">Budget</span>
          <span class="header budget-balance text-right">Budget Balance</span>
        </div>

        <div class="scroller" v-if="hasData">
          <div>
            <div v-for="(item, i) in items"
                 :key="i"
                 class="row detail">
              <span class="status"><span class="indicator" :title="item.ProgramStatusName">{{item.ProgramStatusName}}</span></span>
              <span class="program-name" :title="item.ProgramName"><a :href="item.Url">{{item.ProgramName}}</a></span>
              <span class="budget text-right" :title="item.RevisedBudget">{{item.RevisedBudget}}</span>
              <span class="budget-balance text-right" :tile="item.BudgetBalance">{{item.BudgetBalance}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-holder" v-if='loading'>
        <span class="prog-loading" /> Loading current {{getProgramLabel(true, true)}} ...
      </div>

      <div class="empty-holder" v-if='!loading && !hasData'>
        <i class="fal fa-list" />
        <span>
          <p class="bold">No {{getProgramLabel(true, false)}} Found</p>
          <p class="light">No {{getProgramLabel(true, true)}} are currently open</p>
        </span>
      </div>
  </div>
</template>


<script>
  import { initScrollbar } from '../../helpers/scrollbarHelper.js'
  import { EventBus } from '@/event-bus'
  import Vue from 'vue'
  import user from '@/core/user'
  import VuePluralize from 'vue-pluralize'

  Vue.use(VuePluralize)

  export default {
    alias: 'current-programs-wdg-cmp',

    props: { widget: Object },

    data() {
      return {
        items: [],
        loading: false,
        companySettings: {}
      }
    },

    computed: {
      hasData() {
        if ((this.items !== null) && (this.items.length > 0)) return true
        else {
          return false
        }
      }
    },

    created() {
      this.loading = true
      this.companySettings = user.getCompanySettings()
      this.api.get(this.widget.endPoint, {})
        .then(r => {
          this.items = r.data.items
        })
        .finally(() => {
          this.loading = false

          this.$nextTick(() => {
            let desiredHeight = !this.hasData ? 1 : getDesiredSize(this.items.length)

            EventBus.$emit('updateWidgetHeight', {
              wId: this.widget.id,
              height: desiredHeight,
              alt: -1
            })
            if (this.items.length > 6) {
              this.$el.querySelector('.scroller').style.height = '156px'
              initScrollbar(this, '.scroller')
            }
          })
        })
    },

    methods: {

      getProgramLabel(plural, lower) {
        var label = this.companySettings.ProgramLabel ? this.companySettings.ProgramLabel : 'Program'
        if (plural === true) label = this.companySettings.ProgramsLabel
        if (lower === true) label = label.toLowerCase()
        return label
      }
    }
  }

  function getDesiredSize(len) {
    let res = 1
    if (len >= 6) return 3
    switch (len) {
      case 1: res = 1
        break
      case 2:
      case 3: res = 2
        break
      case 4:
      case 5: res = 3
        break
    }
    return res
  }

</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/_variables.scss";
  a[href] {
    color: $href-blue-color
  }
  .scroller {
    position: relative;
    overflow: hidden;
  }
  
  .empty-holder {
    text-align: center;
    .prog-loading {
        margin-top: 25px;
        margin-left: 50px;
    }
  }

div.empty-holder {
    position: absolute;
    left: 170px;
    i.fal {
      font-size: 1.7rem;
      height: 50px;
      width: 50px;
      padding-top:10px;
      padding-left:1px;
      background-color:#f2f2f2;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
    text-align: center;
    margin-top: 0px;
    color: #9c9c9c;
    font-size: 0.96em;
    font-weight: 600;
    span{
      text-align: left;
      display: inline-block;
      p{
        line-height: 0.4rem;
        display:block;
        &.bold{
          font-weight: 650
        }
        &.light{
          font-size: 0.8rem;
          font-weight: 200;
        }
      }
    }
  }

  .indicator {
    border-radius: 5px;
    padding: 1px 4px;
    font-size: 0.75rem;
    border: 1px solid $main-black;
    background-color: white;
    color: $main-black;
    font-weight: 100;
    line-height: 1.2em;
    position: absolute;
    top: 0.1em;
    max-width: 12%;
  }

  .header {
    text-transform: uppercase;
    font-weight: 600;
    padding: 4px 0;

  }
  .programs-loading{
      margin-top: 25px;
      margin-left: 55px;
  }

  .row {
    &.bottom-border{
          @include theme {
      border-bottom: 1px solid v(background-light);
      }
      margin-bottom:3px;
    }
    clear: both;
    font-size: $font-size-xsmall;
    line-height: 1.7em;
    padding: 0 1.5em 0 .6em;
    position:relative;
  }

  .row.detail span {
    margin-top: 0.5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .status {
    display: inline-block;
    width: 14%;
    float: left;
    border-radius: 5px;
  }

  .program-name {
    display: inline-block;
    width: 42%;
    float: left;
  }

  .budget {
    display: inline-block;
    width: 21%;
    float: left;
  }

  .budget-balance {
    display: inline-block;
    width: 21%;
    float:right;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/CurrentPrograms/index.vue